import React, { useMemo } from "react";
import { buildOrderDiscountInfo, calcOrderProfit } from "@/utils/OrderUtils";
import OrderDTO from "@/dto/order/OrderDTO";
import { observer } from "mobx-react-lite";
import LuckyMoney from "./LuckyMoney";
import { isEmpty } from "@/utils";
import { Link } from "react-router-dom";

interface OrderPaymentSummaryProps {
    order: Pick<
        OrderDTO,
        | "shippingFee"
        | "platformDiscounts"
        | "payments"
        | "sellerReceipts"
        | "discounts"
        | "adjustAmounts"
        | "adjustments"
        | "tags"
    >;
}

/**
 * 订单支付信息，包括运费、平台优惠以及卖家实收相关
 */
const OrderPaymentSummary: React.FC<OrderPaymentSummaryProps> = observer((props) => {
    const { order } = props;

    const discountsInfo = buildOrderDiscountInfo(order);

    const shippingFeeEl = `运费:${order.shippingFee || 0}元`;
    const discountsEl = order.platformDiscounts ? `平台优惠:${order.platformDiscounts}元` : null;

    const shippingFeeAndDiscount = [shippingFeeEl, discountsInfo, discountsEl].filter((it) => !!it).join("，");

    const profit = useMemo(() => calcOrderProfit(order as any), [order]);
    const isCostPriceNotSet = useMemo(
        () =>
            (order as OrderDTO).sellerReceipts &&
            (order as OrderDTO).orderItems?.length &&
            (order as OrderDTO).orderItems?.every?.((orderItem) => isEmpty(orderItem?.cost)),
        [order],
    );

    return (
        <>
            <span className="order-payments">实付款: {order.payments}</span>

            <LuckyMoney orderTags={order.tags} />

            {shippingFeeAndDiscount ? (
                <span className="shipping-fee discount">（{shippingFeeAndDiscount}）</span>
            ) : null}

            {order.sellerReceipts ? <span>卖家实收：{order.sellerReceipts}元</span> : null}
            {order.payments && order.sellerReceipts && order.payments !== order.sellerReceipts ? (
                <span className="small text-gray">（买家实付款+平台优惠）</span>
            ) : null}

            {isCostPriceNotSet ? (
                <span>
                    利润:
                    <Link to="/setting/product" className="ml3">
                        编辑成本价
                    </Link>
                </span>
            ) : null}
            {profit ? <span>利润:{profit}</span> : null}
        </>
    );
});

export default OrderPaymentSummary;
